import { Dispatch, SetStateAction } from 'react';
import ExerciseAnswersModal from './exercise-answers-modal';
import { AnalyticsData } from '../../../../hooks/constants/Analytics';
import ActiveSessionModal from './active-session-modal';
import { ExercisePhase } from '../../@types/exercise-types';
import { PauseExerciseSessionResponse, StopExerciseSessionResponse } from '../../api/exercises-api';

interface ExerciseActivityModalsProps {
  reviewSessionId?: string;
  analyticsData?: AnalyticsData;
  phaseAction: ExercisePhase | undefined;
  onSessionPaused: (session: PauseExerciseSessionResponse) => void;
  onSessionFinished: (result: StopExerciseSessionResponse) => void;
  setPhase: Dispatch<SetStateAction<'launch' | 'activity' | 'progression' | undefined>>;
}

function ExerciseActivityModals({
  reviewSessionId,
  analyticsData,
  phaseAction,
  onSessionPaused,
  onSessionFinished,
  setPhase,
}: ExerciseActivityModalsProps): JSX.Element {
  return reviewSessionId ? (
    <ExerciseAnswersModal sessionId={reviewSessionId} analyticsData={analyticsData} />
  ) : (
    <ActiveSessionModal
      phaseAction={phaseAction}
      analyticsData={analyticsData}
      onSessionPaused={onSessionPaused}
      onSessionFinished={onSessionFinished}
      setPhase={setPhase}
    />
  );
}

export default ExerciseActivityModals;
